import { render, staticRenderFns } from "./AppAjaxContent.vue?vue&type=template&id=6b6ad228&scoped=true"
import script from "./AppAjaxContent.vue?vue&type=script&lang=js"
export * from "./AppAjaxContent.vue?vue&type=script&lang=js"
import style0 from "./AppAjaxContent.vue?vue&type=style&index=0&id=6b6ad228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ad228",
  null
  
)

export default component.exports